export const nFormatter = (num: number, digits: number) => {
  // Проверка на ноль в начале функции
  if (num === 0) {
    return '0 руб.';
  }

  const lookup = [
    { value: 1e12, symbol: ' трлн.руб.' },
    { value: 1e9, symbol: ' млрд.руб.' },
    { value: 1e6, symbol: ' млн.руб.' },
    { value: 1e3, symbol: ' тыс.руб.' },
    { value: 1, symbol: ' руб.' },
  ];

  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  const sign = num < 0 ? '-' : '';
  const absNum = Math.abs(num);
  const item = lookup.find((item) => absNum >= item.value);

  if (!item) {
    return sign + '0 руб.';
  }

  // Получаем значение с максимальным количеством знаков после запятой
  let val = (absNum / item.value).toFixed(5);

  // Применяем последовательное округление до нужного количества знаков
  switch (digits) {
    case 4:
      val = Number(val).toFixed(digits);
      break;
    case 3:
      val = Number(Number(val).toFixed(4)).toFixed(digits);
      break;
    case 2:
      val = Number(Number(val).toFixed(4)).toFixed(3);
      val = Number(val).toFixed(digits);
      break;
    case 1:
      val = Number(Number(Number(val).toFixed(4)).toFixed(3)).toFixed(2);
      val = Number(val).toFixed(digits);
      break;
    default:
      val = Number(val).toFixed(digits);
  }

  return sign + val.replace(rx, '$1') + item.symbol;
};
